import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { BackendModule } from '@shared/datastore/core';
import { notificationsBackend } from './notifications.backend';
import { notificationsReducer } from './notifications.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('notifications', notificationsReducer),
    BackendModule.forFeature('notifications', notificationsBackend),
  ],
})
export class DatastoreNotificationsModule {}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/notifications/notifications.module.ts